import { FilterField, User } from '../../types'

const reportingFields = (dateRangeFieldId: string, ownerUsers: User[]): FilterField[] => [
  {
    id: dateRangeFieldId,
    display: 'Created At',
    filterTypeIds: ['date_time_in_range'],
  },
  {
    id: 'owner_user_id',
    display: 'RFQ Owner',
    filterTypeIds: ['is'],
    options: ownerUsers.map((ownerUser) => ({
      id: ownerUser.id,
      display: ownerUser.name || ownerUser.email,
    })),
  },
]

export default reportingFields
